import api from "./api";
import { isAuthenticated } from "./auth";

function sendApiHeartbeat() {
  api.post("/heartbeat").catch((e) => console.error(e));
}

export function initHeartbeat() {
  if (isAuthenticated()) sendApiHeartbeat();
  return setInterval(() => {
    if (isAuthenticated()) sendApiHeartbeat();
  }, 1000 * 60);
}
